import React from 'react'

const AccessManagement = () => {
  return (
    <header className='headerEditor'><h2>AccessManagement</h2></header>
  )
}

export default AccessManagement